export enum OptionMode {
  Options = 'options',
  GrouppedOptions = 'grouppedOptions'
}
